import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import { Field, FieldArray } from 'formik';
import { TextAreaFormField } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  QuestionIndex,
  AddQuestion,
} from './styles';

import ErrorMessage from '../error';
import PreferenceUploadRow from './preference-upload-row';

const SURVEYS_PAGES_PREFIX = 'surveysPages';
const TASKS_PREFIX = 'tasks';

const generateNewAnswer = () => ({ id: v4(), label: '', optionType: 'answer' });

const MAXIMUM_PREFERENCES = 8;

const Preference = (props) => {
  const {
    question,
    index,
    errors,
    touched,
    setFieldValue,
    isEdit,
    taskIndex,
    testType,
  } = props;

  const {
    questionOptions,
  } = question;

  const [uploadError, setUploadError] = useState('');

  const generateBaseTask = () => {
    let baseTaskPreffix = '';
    if (typeof (taskIndex) === 'number') {
      const indexerSufixString = `[${taskIndex}].`;
      const arrayReferenceString = testType === 'survey' ? SURVEYS_PAGES_PREFIX : TASKS_PREFIX;
      baseTaskPreffix = `${arrayReferenceString}${indexerSufixString}`;
    }

    const baseTaskPositionString = `${baseTaskPreffix}tasks.${index}`;
    return baseTaskPositionString;
  };

  const baseTaskString = generateBaseTask();

  const label = `${baseTaskString}.label`;

  const nameFieldArray = `${baseTaskString}.questionOptions`;

  const handleChangeImage = (imageUrl, imageKey, optionIndex) => {
    const currentOption = questionOptions[optionIndex];
    const newQuestion = {
      ...currentOption,
      imageKey,
      imageUrl,
    };
    setFieldValue(`${nameFieldArray}.${optionIndex}`, newQuestion);
  };
  const disabled = isEdit || questionOptions?.length <= 2;

  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-preference.png" />
        <Title color="questionTitlePreference">
          Preference Test
        </Title>
      </ContainerTitle>
      <Field
        placeholder="Start typing your question"
        minWidth="100%"
        component={TextAreaFormField}
        name={label}
      />
      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
      />
      <FieldArray
        name={nameFieldArray}
        render={
          ({ remove, push }) => (
            <>
              {
                questionOptions?.map(({ imageKey, imageUrl }, optionIndex) => (
                  <PreferenceUploadRow
                    label={`${nameFieldArray}.${optionIndex}.label`}
                    handleRemove={() => remove(optionIndex)}
                    uploadConfig={
                      {
                        index: optionIndex,
                        handleChangeImage,
                        question,
                        setUploadError,
                        imageKey,
                        imageUrl,
                      }
                    }
                    disabled={disabled}
                    isEdit={isEdit}
                  />
                ))
              }
              {
                questionOptions?.length < MAXIMUM_PREFERENCES
                && !isEdit
                && (
                  <AddQuestion onClick={() => push(generateNewAnswer())}>
                    Add another option
                  </AddQuestion>
                )
              }
            </>
          )
        }
      />
      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
        uploadError={uploadError}
      />
    </Container>
  );
};

Preference.propTypes = {
  question: PropTypes.shape(
    {
      questionOptions: PropTypes.arrayOf(
        PropTypes.shape(
          {
            label: PropTypes.string,
            imageKey: PropTypes.string,
            imageUrl: PropTypes.string,
          },
        ),
      ),
    },
  ).isRequired,
  index: PropTypes.number.isRequired,
  errors: PropTypes.shape(
    {
      label: PropTypes.string,
    },
  ).isRequired,
  touched: PropTypes.shape({
    label: PropTypes.bool,
  }).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
  taskIndex: PropTypes.number,
  testType: PropTypes.string.isRequired,
};

Preference.defaultProps = {
  isEdit: false,
  taskIndex: null,
};

export default Preference;
